"use client";

import { Slider } from "@base-ui/react/slider";
import { cn } from "cn";

interface StripeSliderProps {
  ariaLabel: string;
  background: string;
  className?: string;
  max: number;
  min?: number;
  onChange: (value: number) => void;
  step?: number;
  value: number;
}

export function StripeSlider({
  ariaLabel,
  background,
  value,
  min = 0,
  max,
  step = 1,
  onChange,
  className,
}: StripeSliderProps) {
  return (
    <Slider.Root
      className={cn("w-full", className)}
      max={max}
      min={min}
      onValueChange={onChange}
      step={step}
      thumbAlignment="center"
      value={value}
    >
      <Slider.Control className="flex w-full cursor-ew-resize touch-pan-y items-center rounded-full bg-surface p-1 shadow-raised">
        <div
          className="flex h-10 w-full rounded-full outline-subtle"
          style={{ background }}
        >
          <Slider.Track className="mx-5 h-full w-full">
            <Slider.Thumb
              aria-label={ariaLabel}
              className="size-6 rounded-full border-4 border-white shadow-[0_0_0_1px_rgba(0,0,0,0.25)] transition-transform duration-150 ease-out active:scale-110"
            />
          </Slider.Track>
        </div>
      </Slider.Control>
    </Slider.Root>
  );
}
